import React from "react";
import { useNavigate } from "react-router-dom";
function StartWorkOut(props) {
  const navigate = useNavigate();

  function handleStartWorkOut() {
    props.getData();
    navigate("/exercises");
  }

  return (
    <div>
      <button
        className="bg-green-500 hover:bg-green-700 text-white font-bold py-3 px-4 rounded-3xl focus:outline-none focus:shadow-outline w-52"
        onClick={handleStartWorkOut}
      >
        NEXT
      </button>
    </div>
  );
}
export default StartWorkOut;
